import React, { useState } from 'react';
import { apiPost } from '../../api';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateModeratorPassword = () => {
  const { id } = useParams();
  const [form, setForm] = useState({ password: '', confPassword: '', currentPassword: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confPassword) {
      toast.error('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await apiPost('/api/admin/moderators/update-password', { ...form, moderatorId: id });
      toast.success('Password updated successfully');
      setForm({ password: '', confPassword: '', currentPassword: '' });
      navigate('/moderators');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-6">Update <span className="text-gradient-ginox">Password</span></h1>

      <form onSubmit={handleSubmit}>
        <div className="p-5 mb-6 space-y-4">
          {/* New Password */}
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              New Password
            </label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              placeholder="••••••••"
              required
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Confirm New Password
            </label>
            <input
              type="password"
              name="confPassword"
              value={form.confPassword}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              placeholder="••••••••"
              required
            />
          </div>

          {/* Optionally, add current password field if needed */}
          {/* <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Current Password
            </label>
            <input
              type="password"
              name="currentPassword"
              value={form.currentPassword}
              onChange={handleChange}
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              placeholder="••••••••"
            />
          </div> */}
        </div>

        <div className="flex items-center gap-3">
          <button
            type="submit"
            className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save Password'}
          </button>
          <button
            type="button"
            className="rounded-md border border-border/70 bg-white/[0.02] px-4 py-2 text-xs text-muted-foreground hover:bg-white/[0.05] hover:text-foreground transition-colors"
            onClick={() => navigate('/moderators')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateModeratorPassword;
